<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ijbbyT/tc-custom/cover.jpg?1684514597616?1703426761135" alt="This image is the cover for the book New Mexico Filmmaking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">New Mexico Filmmaking
      </h1>
      <p class="bookDescription body article font2">
        <p>The moderate climate and majestic western landscapes of New Mexico make it an enchanting locale for the motion picture industry. Thomas A. Edison's crew shot the very first film in the state at the Isleta Indian Pueblo in 1897. Silent-era icons like directors Romaine Fielding and Tom Mix shortly followed to take over the small town of Las Vegas, setting the stage for an explosion of western movies. Today, New Mexico's generous incentive programs and quality facilities make it one of the top filming destinations in the country, attracting big projects like the Academy Award-winning No Country for Old Men and AMC's critically acclaimed television series Breaking Bad. In this comprehensive volume, local author and film historian Jeff Berg explores the history and legacy of New Mexico on the big screen.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeff Berg
      </h2>
      
      <p class="authorDescription body article">Jeff Berg is a freelance writer, journalist and New Mexico film historian living in Santa Fe. He has traveled around New Mexico from corner to corner presenting his noted "Made in New Mexico" film clip series, doing live narration for each show. Previously, he served on the board of the Mesilla Valley Film Society and was an assistant manager at the Jean Cocteau Cinema in Santa Fe.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e4cc753